import { render, staticRenderFns } from "./SelectorTipoFornecedor.vue?vue&type=template&id=5504925a&scoped=true"
import script from "./SelectorTipoFornecedor.vue?vue&type=script&lang=js"
export * from "./SelectorTipoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504925a",
  null
  
)

export default component.exports